module.exports = __webpack_public_path__ + "static/media/43.3746b0a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/43.jpg
// module id = 303
// module chunks = 0